





















































import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';
import {formatDate} from "@/utils/formatters";
import dataProxy from '@/services/data-proxy.service';
import {RadniNalog} from "@/services/BackendProxies";
import PotvrdaStavkiRezervnihDelova from "@/views/Odrzavanje/Dokumenta/RadniNalog/PotvrdaStavkiRezervnihDelova.vue";
import PotvrdaStavkiServisnihOperacija
    from "@/views/Odrzavanje/Dokumenta/RadniNalog/PotvrdaStavkiServisnihOperacija.vue";
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component({components: {PotvrdaStavkiRezervnihDelova, PotvrdaStavkiServisnihOperacija}})
export default class PotvrdaInternogRadnogNaloga extends mixins(ComponentBaseMixin) {

    columns = [];
    radniNalozi = [];
    dialogOpen = false;
    radniNalog = RadniNalog.fromJS({servisneOperacije: [], delovi: []});

    created() {
        this.columns = [
            {field: 'broj', title: this.$i18n.t('broj')},
            {field: 'datum', title: this.$i18n.t('datum'), formatter: formatDate},
            {field: 'vozilo', title: this.$i18n.t('vozilo')},
            {field: 'dokumentKreirao', title: this.$i18n.t('dokumentKreirao')},
        ];
        this.reload();
    }

    get datum() {
        return formatDate(this.radniNalog.datum);
    }

    async edit(row: RadniNalog) {
        const radniNalog = await this.loadData(() => dataProxy.vratiZatvorenInterniRadniNalogPoId(row.id))();
        radniNalog.servisneOperacije.forEach(s => s.utrosenaKolicina = s.kolicina);
        this.radniNalog = radniNalog;
        this.dialogOpen = true;
    }

    async potvrdiRadniNalog() {
        const postojiNedodeljenaVrstaOdrzavanja = this.radniNalog.servisneOperacije.filter(x => !x.vrstaOdrzavanjaId).length > 0 ||
            this.radniNalog.rezervniDelovi.filter(x => !x.vrstaOdrzavanjaId).length > 0;
        if (postojiNedodeljenaVrstaOdrzavanja) {
            const da = await this.confirmationNeeded('postoje stavke sa ne dodeljenom vrstom odrzavanja')
            if (!da) {
                this.dialogOpen = true;
                return;
            }
        }

        await this.saveData(() => dataProxy.potvrdiIntetniRadniNalog(this.radniNalog))();
        this.dialogOpen = false;
        this.reload();
    }

    async reload() {
        this.radniNalog = RadniNalog.fromJS({servisneOperacije: [], delovi: []});
        this.radniNalozi = await this.loadData(() => dataProxy.vratiZatvoreneInterneRadneNaloge())();
    }
}
